import React from 'react';
import { CheckCircle, ArrowRight, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';

const DiagnosticConfirmation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="Confirmation — Diagnostic Stratégique | Glow Lab"
        description="Ton diagnostic stratégique est confirmé. Vérifie ta boîte mail pour les détails."
        url="https://glow-architecte.com/diagnostic/confirmation"
      />
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-12 md:py-20">
        <div className="text-center max-w-lg">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-[hsl(var(--rose-text))]" strokeWidth={1.5} />
          </div>

          <h1 className="font-display text-3xl sm:text-4xl text-foreground mb-4 leading-[1.1]">
            Paiement confirmé !
          </h1>

          <p className="text-lg text-muted-foreground mb-8 leading-relaxed text-pretty">
            Merci pour ta confiance. Tu vas recevoir un email de confirmation avec tous les détails
            de ton Diagnostic Stratégique.
          </p>

          <div className="bg-muted rounded-2xl border border-border p-6 mb-8 text-left">
            <h3 className="font-display text-lg text-foreground mb-4">Prochaines étapes :</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-foreground">
                <Mail className="w-4 h-4 text-[hsl(var(--rose-text))] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Vérifie ta boîte mail pour la confirmation et le lien visio</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground">
                <CheckCircle className="w-4 h-4 text-[hsl(var(--rose-text))] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Prépare tes questions — on va les aborder pendant la session</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground">
                <ArrowRight className="w-4 h-4 text-[hsl(var(--rose-text))] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Tu recevras ton livrable PDF sous 5 jours après la session</span>
              </li>
            </ul>
          </div>

          <button
            onClick={() => navigate('/')}
            className="bg-primary text-primary-foreground font-semibold text-sm px-6 py-3 rounded-xl hover:scale-[1.02] transition-all duration-300 shadow-[0_4px_20px_hsl(var(--primary)/0.3)]"
          >
            Retour à l'accueil
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DiagnosticConfirmation;
